<div class="other-block block">
  <div class="title">References</div>
  <div class="items">
    <div class="recommendation" *ngIf="!readonly">
      <div class="d-flex align-items-center">
        <div class="input-wrapper d-flex">
          <input
            type="text"
            [(ngModel)]="recommendation"
            (keyup.enter)="onSubmit(); false"
            placeholder="Write recommendation"
          />
        </div>
        <button class="send" (click)="onSubmit(); false">
          <svg viewBox="0 0 26 25">
            <use href="#send" />
          </svg>
        </button>
      </div>
      <div class="anonymous d-flex align-items-center">
        <label><input type="checkbox" [(ngModel)]="is_anonymous" /> <span>Anonymous publication</span></label>
      </div>
    </div>
    <ng-container *ngFor="let review of reviews">
      <div class="item d-flex" *ngIf="!review.is_anonimous">
        <a [profile]="review.user">
          <app-avatar [src]="review.user.icon" [placeholder]="review.user | initials" class="little right"></app-avatar>
        </a>
        <div class="data">
          <a [profile]="review.user" class="name">{{ review.user?.name }}</a>
          <div class="position">{{ review.user?.type_name }}</div>
          <div class="description">{{ review.text }}</div>
        </div>
      </div>
      <div class="item d-flex" *ngIf="review.is_anonimous">
        <div class="avatar rounded-circle">
          <img src="/assets/new_img/avatar%20(4).png" alt="profile-name" class="img-fluid" />
        </div>
        <div class="data">
          <div class="name">Anonymous</div>
          <div class="description">{{ review.text }}</div>
        </div>
      </div>
    </ng-container>
  </div>
</div>
